import { createFileRoute } from "@tanstack/react-router"

import OverallCapacityTab from "~/components/noos-supply-plan/OverallCapacityTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/vendor-management/_layout/capacity")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Procurement - Vendor Management - Capacity Plan")
  return <OverallCapacityTab />
}
